import React, { useEffect, useState } from "react";
import useFetch from "hooks/useFetch";
import { Table, Alert, Form } from "react-bootstrap";
import StatisticsSkeleton from "./StatisticsSkeleton/StatisticsSkeleton";

interface UserScore {
  username: string;
  questionsAnswered: number;
  points: number;
}

const StatisticsPage: React.FC = () => {
  const { data, isLoading, error, execute } = useFetch<UserScore[]>();
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredData, setFilteredData] = useState<UserScore[]>([]);

  useEffect(() => {
    execute("/api/v1/scores", "GET");
  }, []);

  useEffect(() => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    const filtered = (data ?? []).filter(
      (user) =>
        user.username.toLowerCase().includes(lowerSearchTerm) ||
        user.questionsAnswered.toString().includes(lowerSearchTerm) ||
        user.points.toString().includes(lowerSearchTerm),
    );
    setFilteredData(filtered);
  }, [searchTerm, data]);

  if (isLoading) {
    return <StatisticsSkeleton />;
  }

  return (
    <div className="container mt-5">
      <h1 className="mb-4">Quizstatistikk</h1>

      <Form.Control
        type="text"
        placeholder="Søk etter brukernavn, besvarte spørsmål eller poeng..."
        className="mb-4"
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      {error && (
        <Alert variant="danger" className="mt-4">
          Feil: {error.text || "Noe gikk galt. Vennligst prøv igjen senere."}
        </Alert>
      )}

      {!isLoading && !error && (
        <Table striped bordered hover responsive>
          <thead>
            <tr>
              <th>#</th>
              <th>Brukernavn</th>
              <th>Besvarte Spørsmål</th>
              <th>Poeng</th>
            </tr>
          </thead>
          <tbody>
            {filteredData.map((user, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td>{user.username}</td>
                <td>{user.questionsAnswered}</td>
                <td>{user.points}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      )}
    </div>
  );
};

export default StatisticsPage;
